if (!customElements.get('gift-card-balance')) {
  customElements.define('gift-card-balance', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const fieldset = this.querySelector('fieldset');
      const input = this.querySelector('input');
      const button = this.querySelector('button');
      const status = this.querySelector('[data-status]');
      const result = this.querySelector('[data-result]');
      const endpoint = this.dataset.endpoint;
      const mock = this.dataset.mock === 'true';
      const privateTest = this.dataset.privateTest === 'true';
      const previewInput = this.querySelector('[data-preview-token]');
      form.addEventListener('submit', event => event.preventDefault());
      if (!mock && (this.dataset.liveEnabled !== 'true' || !/^\/apps\/[a-zA-Z0-9_\/-]+$/.test(endpoint))) return;
      this.querySelector('[data-unavailable]').hidden = true;
      fieldset.disabled = false;
      input.addEventListener('input', () => {
        result.hidden = true;
        status.textContent = '';
        input.removeAttribute('aria-invalid');
      });
      form.addEventListener('submit', async () => {
        if (this.busy) return;
        result.hidden = true;
        const code = input.value.replace(/[\s-]/g, '').toUpperCase();
        if (!/^[A-Z0-9]{16}$/.test(code)) {
          status.textContent = status.dataset.invalid;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        const previewToken = privateTest ? previewInput?.value.trim() : undefined;
        if (privateTest && (!previewToken || previewToken.length < 32 || previewToken.length > 128)) {
          status.textContent = status.dataset.privateKeyError;
          previewInput?.focus();
          return;
        }
        this.busy = true;
        input.removeAttribute('aria-invalid');
        fieldset.disabled = true;
        form.setAttribute('aria-busy', 'true');
        button.textContent = button.dataset.loading;
        status.textContent = button.dataset.loading;
        const controller = new AbortController();
        this.controller = controller;
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          let data;
          if (mock) {
            await new Promise(resolve => setTimeout(resolve, 700));
            if (this.dataset.previewError === 'true' || controller.signal.aborted) throw new Error();
            data = { amount: '42.50', currencyCode: 'CAD', mock: true };
          } else {
          const response = await fetch(endpoint, {
            method: 'POST', credentials: 'same-origin', cache: 'no-store', redirect: 'error',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ code, ...(privateTest ? { previewToken } : {}) }), signal: controller.signal
          });
          input.value = '';
          if (previewInput) previewInput.value = '';
          if (!response.ok) {
            const failure = await response.json().catch(() => ({}));
            status.textContent = response.status === 429 ? status.dataset.rateLimit :
              response.status === 404 && failure?.error === 'unverified' ? status.dataset.notFound :
              response.status === 410 ? status.dataset.inactive : status.dataset.error;
            return;
          }
          data = await response.json();
          if (data.mock === true) throw new Error();
          }
          if (!data || typeof data.amount !== 'string' || !/^\d{1,12}(\.\d{1,6})?$/.test(data.amount) ||
              typeof data.currencyCode !== 'string' || !/^[A-Z]{3}$/.test(data.currencyCode)) throw new Error();
          const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency', currency: data.currencyCode, currencyDisplay: 'code'
          }).format(Number(data.amount));
          this.querySelector('[data-amount]').textContent = formatted;
          this.querySelector('[data-mock-result]').hidden = !mock;
          status.textContent = mock ? this.dataset.mockLabel + ' ' + formatted : formatted;
          result.hidden = false;
          result.focus();
        } catch {
          status.textContent = status.dataset.error;
        } finally {
          clearTimeout(timeout);
          input.value = '';
          if (previewInput) previewInput.value = '';
          fieldset.disabled = false;
          form.removeAttribute('aria-busy');
          button.textContent = button.dataset.idle;
          this.busy = false;
        }
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
